"use client";

import { PilotProgramPage } from "@/components/shared/pilot-program-page";
import { BenefitsRow } from "@/components/shared/benefits_row";

const requirements = [
  {
    title: "Betrokken faculteit",
    description: "Enkele enthousiaste studenten en docenten die open staan voor het verkennen van nieuwe AI-technologieën."
  },
  {
    title: "Bestuurlijke ondersteuning",
    description: "Betrek een senior sponsor (bijv. rector, directeur onderwijs & leren, CIO) om te helpen bij het vormgeven van de pilot-evaluatie."
  },
  {
    title: "Duidelijke doelen",
    description: "De doelen van de universiteit staan voorop – we werken samen om deze te bereiken."
  },
  {
    title: "Gedegen samenwerking",
    description: "Inrichting en evaluatie in samenspraak met de universiteit."
  },
  {
    title: "Evaluatieperiode",
    description: "Een onderwijsperiode in laatste semester 2026–2027."
  },
  {
    title: "Bescheiden budget",
    description: "Slechts een kleine bijdrage voor het uitvoeren van de pilot."
  }
];

export default function NlPilot() {
  return (
    <PilotProgramPage
      variant="nl"
      title={<>Doe mee aan de StudyStash<br />2026 studenten pilot</>}
      subtitle="Volledige academische integriteit en inhoudsbeveiliging. Geef studenten een veilige plek om leerstof efficiënt eigen te maken."
      caseStudyLink="/about/case-studies/university-of-birmingham"
      caseStudyImage="/uob_studystash.png"
      caseStudyAlt="University of Birmingham StudyStash Case Study"
      reportImage="/uob_studystash_right.png"
      reportAlt="University of Birmingham StudyStash Rapport"
      whyPilotTitle="Waarom partnerschap met StudyStash?"
      whyPilotContent="Luister naar studenten en docenten"
      institutionType="institution"
      requirements={requirements}
      showFAQ={false}
      partnershipHeading="Een partnerschap om verandering te stimuleren"
      collaborationSubheading="Dit hebben we nodig voor een succesvolle samenwerking:"
      caseStudyLinkText="Lees het volledige verhaal →"
      reportHeading="Lees de EAB Case Study"
      reportLinkText="Lees het rapport →"
      applyNowText="Nu aanmelden"
      learnMoreText="Meer informatie"
      additionalContent={{
        heading: "Waarom partnerschap met StudyStash?",
        paragraph: "Partnerschap voor verbetering van leerresultaten.",
        benefits: [
          "Lage kosten",
          "Laag risico", 
          "Docentvriendelijk"
        ],
        additionalSections: [],
        unlockSection: {
          heading: "Partnerschap voor verbetering van leerresultaten",
          paragraph: "Geef studenten een veilige plek om leerstof efficiënt eigen te maken. Door veilig afgeschermde AI omgeving altijd de juiste antwoorden.",
          image: "/stock8.jpg",
          imageAlt: "Professionele samenwerking en partnerschap"
        },
        pilotSection: {
          heading: "Laag risico, lage kosten",
          paragraph: "Werkt stand-alone of als plug-in voor LMS. Probleemloze installatie door studenten en docenten. Pilot: betaalbare en laagdrempelige pilotkosten",
          image: "/lecturer-classroom.jpg",
          imageAlt: "Docent in klaslokaal"
        },
        benefitsRow: {
          heading: "",
          description: "",
          cards: [
            {
              title: "Studenten",
              bulletPoints: [
                {
                  icon: "/icon-pack/StudyStash - Icon - Home.png",
                  text: "Al je leerstof op één plek, plan wat je wilt leren"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Chat.png", 
                  text: "Slimme en soms 'Game-like study tools'"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Graph.png",
                  text: "Veilige AI zorgt voor juiste antwoorden"
                }
              ],
              image: "/stock8.jpg",
              imageAlt: "Studenten in klaslokaal met instructeur",
              bgColor: "bg-ss-blue"
            },
            {
              title: "Docenten",
              bulletPoints: [
                {
                  icon: "/icon-pack/StudyStash - Icon - Chat.png",
                  text: "Feedback over leerstof die extra aandacht vraagt"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Graph.png",
                  text: "Het niveau van de vragen gaat omhoog"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Pen.png",
                  text: "Minder e-mails, meer tijd voor onderwijs"
                }
              ],
              image: "/lecturer-classroom.jpg",
              imageAlt: "Docent die lesgeeft in klaslokaal",
              bgColor: "bg-ss-green"
            },
            {
              title: "Universiteiten",
              bulletPoints: [
                {
                  icon: "/icon-pack/StudyStash - Icon - Arrow.png",
                  text: "Werkt stand-alone of als plug-in voor LMS"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Lock.png",
                  text: "Probleemloze installatie door studenten en docenten"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Graph.png",
                  text: "Pilot: betaalbare en laagdrempelige pilotkosten"
                }
              ],
              image: "/stock_3.jpg",
              imageAlt: "Student die studeert en schrijft",
              bgColor: "bg-ss-purple"
            }
          ]
        }
      }}
    />
  );
}

